module.exports = __webpack_public_path__ + "static/charlesgate-confidential-a4655f2dbcdf8fe57416b0af4d1bbbcc.jpg";